import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, AlertCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { admin, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-tratou-dim font-mono">Loading...</div>;
  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, pw);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative noise" data-testid="admin-login">
      <div className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-40" />
      <form onSubmit={submit} className="panel p-10 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img src="/tratou-logo.png" alt="Tratou Energy" className="h-6 w-auto" />
          <span className="font-mono text-[10px] tracking-[0.25em] text-tratou-dim border-l border-white/10 pl-3">ADMIN</span>
        </div>
        <span className="eyebrow">Operator Console</span>
        <h1 className="heading-section mt-3" style={{ fontSize: "2rem" }}>Sign in.</h1>

        <div className="mt-8 space-y-5">
          <div>
            <label className="field-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-tratou-void/80 border border-white/10 px-4 py-3 outline-none focus:border-tratou-green/60 text-sm"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="field-label">Password</label>
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              required
              className="w-full bg-tratou-void/80 border border-white/10 px-4 py-3 outline-none focus:border-tratou-green/60 text-sm"
              data-testid="admin-password"
            />
          </div>
        </div>

        {err && (
          <div className="mt-5 flex items-start gap-2 text-red-400 text-sm" data-testid="admin-error">
            <AlertCircle className="w-4 h-4 mt-0.5" /> <span>{err}</span>
          </div>
        )}

        <button type="submit" disabled={busy} className="btn-primary mt-7 w-full justify-center disabled:opacity-50" data-testid="admin-submit">
          <Lock className="w-4 h-4" /> {busy ? "Authenticating..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
